import { GachaAnimation, GachaReveal, GachaRevealSkin, GachaSkinLabel, PortalScene, SideScene } from './gachaAssets';

export const googleFonts: string[] = ['Poppins', 'Titan One'];
export const mixinList: any = {
	GachaAnimation, GachaReveal, GachaRevealSkin, GachaSkinLabel, PortalScene, SideScene,
};
